// extracted by mini-css-extract-plugin
export default {"fraseContainer":"Pessoa_fraseContainer__WuTKl","fraseContent":"Pessoa_fraseContent__vJHcC"};